export default __webpack_public_path__ + "static/media/chat-bubble.a8c6026f.svg";